import constants from '../config/constants';

const defaultUserInfo = {
  name: constants.tournament+' '+new Date().getFullYear(),
  image: '/static/media/logo.png'
};

export default function reducer(state = {
  user: defaultUserInfo
}, action) {
  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Auth.js